import { render } from "./LbrxRebootPopup.vue?vue&type=template&id=64ad2827&scoped=true"
import script from "./LbrxRebootPopup.vue?vue&type=script&lang=js"
export * from "./LbrxRebootPopup.vue?vue&type=script&lang=js"

import "./LbrxRebootPopup.vue?vue&type=style&index=0&id=64ad2827&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ad2827"]])

export default __exports__